import * as S from "../styles";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoCompleteMult from "@/components/hookForms/autoCompleteMult";
import { Button } from "@mui/material";
import CheckBox from "@/components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerMui from "@/components/hookForms/datePicker";
import IGenericResult from "@/interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import { format } from "date-fns";
import messages from "@/utils/messages";
import serviceClientes from "@/services/serviceCliente";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import serviceInstalacao from "@/services/serviceInstalacao";
import serviceRelatorio from "@/services/serviceRelatorio";
import serviceUsina from "@/services/serviceUsina";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function ResumoFaturamento({ open, onClose }: IDialogProps) {
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [instalacaoDataOptions, setInstalacaoDataOptions] = useState<IGenericResult[]>([]);
    const [clienteOptions, setClienteOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [disabled, setDisabled] = useState(false);
    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            dataInicio: "",
            dataFim: "",
            idsInstalacoes: "",
            idsClientes: "",
            idsUsinas:"",
            idsConcessionarias: "",
        },
    });

    useEffect(() => {
        setUsinaData();
        setInstalacaoData();
        setClienteData();
        setConcessionariaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const setInstalacaoData = async () => {
        serviceInstalacao
            .getInstalacoes()
            .then((result) => {
                setInstalacaoDataOptions(result?.data);
            })
            .catch(() => {
                setInstalacaoDataOptions([]);
            });
    };

    const setClienteData = async () => {
        serviceClientes
            .getClientes()
            .then((result) => {
                setClienteOptions(result?.data);
            })
            .catch(() => {
                setClienteOptions([]);
            });
    };

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisabled(true);
        const newValues = {
            ...values,
            relatorioTipoID: 19,
            dataInicio: values.dataInicio ? format(values.dataInicio, "yyyy-MM-01") : "",
            dataFim: values.dataFim ? format(values.dataFim, "yyyy-MM-01") : "",
            idsInstalacoes: values.idsInstalacoes ? values.idsInstalacoes.join(", ") : "",
            idsClientes: values.idsClientes ? values.idsClientes.join(", ") : "",
            idsUsinas: values.idsUsinas ? values.idsUsinas.join(", ") : "",
            idsConcessionarias: values.idsConcessionarias ? values.idsConcessionarias.join(", ") : "",
        };

        serviceRelatorio
            .getRelatorioResumoFaturamento(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                if (newValues.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Resumo do Faturamento</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(onclose);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {disabled && (
                                <S.Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </S.Loader>
                            )}
                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataInicio"
                                    label="Inicio"
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataFim"
                                    label="Fim"
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsInstalacoes"
                                    label="Instalação"
                                    options={instalacaoDataOptions}
                                    control={control}
                                    error={errors}
                                    concatWithID={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsClientes"
                                    label="Cliente"
                                    control={control}
                                    error={errors}
                                    options={clienteOptions}
                                    concatWithID={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsUsinas"
                                    label="Nome da Usina"
                                    options={usinaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsConcessionarias"
                                    label="Concessionarias"
                                    options={concessionariaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <CheckBox
                                    name="redirecionar"
                                    label="Redirecionar para a tela de relatório"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose(onClose);
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <Button
                            disabled={disabled}
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {}}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
